export function reorderArray(arr: Array<any>, index: number, nextIndex: number) {
	const item = arr[index];
	let nextArr = [...arr];

	nextArr.splice(index, 1);
	nextArr = nextArr.slice(0, nextIndex).concat(item).concat(nextArr.splice(nextIndex));

	return nextArr;
}
